import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import WarningIcon from "@mui/icons-material/Warning";
import { red } from "@mui/material/colors";
import Checkbox from "@mui/material/Checkbox";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable"; 
import IconButton from "@mui/material/IconButton";
import MDButton from "components/MDButton";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import { validateName } from "../validations";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import LogoutButton from "layouts/logout";
import { useNavigate } from "react-router-dom";
import api from "core/interceptors/api";
import { disableBackNavigation } from "core/utils/storage";

const columns = [
  {
    Header: "S.No.",
    accessor: "s_no",
    sortable: true,
  },
  {
    Header: "Category Name",
    accessor: "category_name",
    sortable: true,
  },
  {
    Header: "Parent Category",
    accessor: "parent_category_name",
    sortable: true,
  },
  {
    Header: "Options",
    accessor: "option",
  },
];

function Category() {
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [isParentDisabled, setIsParentDisabled] = useState(true);
  const [Input, setInput] = useState({ parent_category_name: "" });
  const [categoryData, setCategoryData] = useState({
    name: "Root",
    children: [],
  });
  const [updateCategoryData, setUpdateCategoryData] = useState({
    name: "",
    children: [],
  });
  const [editInput, setEditInput] = useState({ parent_category_name: "" });
  const [deleteCategoryId, setDeleteCategoryId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [isEditEnabled, setIsEditEnabled] = useState(false);
  const email = localStorage.getItem("email");
  const navigate = useNavigate();

  
  const [page, setPage] = useState(0); 
  const [rowsPerPage, setRowsPerPage] = useState(10); 
  

  useEffect(() => {
    disableBackNavigation();
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const email = localStorage.getItem("email");
      const res = await api.get(`/category/fetch`, {
        params: { email },
      });
      setCategories(res.data || []);
      
      if (page * rowsPerPage >= (res.data || []).length && (res.data || []).length > 0) {
        setPage(0);
      } else if ((res.data || []).length === 0) {
        setPage(0); 
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to fetch categories. Please try again.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const addCategory = async (event) => {
    event.preventDefault();

    const parentCategoryName = isParentDisabled ? "" : Input.parent_category_name;

    if (!Input.category_name || (!isParentDisabled && !parentCategoryName)) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        category_name: !Input.category_name ? "Category name is required." : "",
        parent_category_name: (!isParentDisabled && !parentCategoryName) ? "Parent category is required." : "",
      }));
      return;
    }


    try {
      const response = await api.post("/category/add", {
        category_name: Input.category_name,
        parent_category_name: parentCategoryName,
        user_id: email,
        created_by: email,
      });

      handleClose();

      if (response.data.success) {
        Swal.fire({
          title: "Successfully Inserted!",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
        fetchCategories(); 
        setPage(0); 
      } else {
        Swal.fire({
          title: "Error",
          text: response.data.message || "Server Problem. Please Try Again...",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error adding record:", error);
      Swal.fire({
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred",
        icon: "error",
      });
    }
  };

  const updateCategory = async (event) => {
    event.preventDefault();

    
    if (!editInput.category_name) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        category_name: "Category name is required.",
      }));
      return;
    }

    try {
      const res = await api.put(`/category/edit/${editInput.id}`, {
        category_name: editInput.category_name,
        parent_category_name: editInput.parent_category_name,
      });

      handleClose();

      if (res.data.success === true) {
        Swal.fire({
          title: "Successfully Updated!",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
        fetchCategories(); 
      } else {
        Swal.fire({
          icon: "error",
          text: res.data.msg,
          type: "error",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error updating category:", error);
      Swal.fire({
        title: "Error",
        text: "An unexpected error occurred. Please try again.",
        icon: "error",
      });
    }
  };

  const deleteCategory = async (event) => {
    event.preventDefault();
    if (deleteCategoryId) {
      try {
        const response = await api.delete(`/category/delete/${deleteCategoryId}`);
        handleClose();
        if (response.data.success) {
          Swal.fire({
            icon: "success",
            text: "Successfully deleted...",
            type: "success",
            timer: 2000,
            showConfirmButton: false,
          });
          fetchCategories(); 
          setPage(0); 
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message || "Server Problem. Please Try Again...",
            type: "error",
            timer: 2000,
            showConfirmButton: false,
          });
        }
      } catch (error) {
        console.error("Error deleting category:", error);
        Swal.fire({
          icon: "error",
          text: "An unexpected error occurred. Please try again.",
          type: "error",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } else {
      console.error("No category ID provided for deletion.");
      Swal.fire({
        icon: "error",
        text: "No category selected for deletion.",
      });
    }
  };

  const toggleParentCategory = () => {
    setIsParentDisabled((prev) => {
      const newState = !prev;

      if (newState) {
        setInput((prevInput) => ({ ...prevInput, parent_category_name: "" }));
        setValidationErrors((prevErrors) => ({ ...prevErrors, parent_category_name: "" }));
      } else {
        
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          parent_category_name: Input.parent_category_name ? "" : "Parent category is required.",
        }));
      }
      return newState;
    });
  };

  const handleAddChange = (e) => {
    const { name, value } = e.target;
    const updatedInput = { ...Input, [name]: value };
    setInput(updatedInput);

    let errors = "";
    if (name === "category_name") {
      errors = validateName(value);
    } else if (name === "parent_category_name" && !isParentDisabled) {
      errors = value ? "" : "Parent category cannot be empty.";
    }

    setValidationErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors, [name]: errors };

      const isCategoryNameValid =
        !!updatedInput.category_name && !updatedErrors.category_name;
      const isParentCategorySelected =
        isParentDisabled || (!!updatedInput.parent_category_name && !updatedErrors.parent_category_name);

      setIsSaveEnabled(isCategoryNameValid && isParentCategorySelected && Object.values(updatedErrors).every((err) => !err));

      return updatedErrors;
    });
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    const updatedInput = { ...editInput, [name]: value };

    setEditInput(updatedInput);

    let errors = "";

    if (name === "category_name") {
      errors = validateName(value);
    }

    setValidationErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors, [name]: errors };

      const isCategoryValid =
        !!updatedInput.category_name && !updatedErrors.category_name;

      const noErrors = Object.values(updatedErrors).every((error) => !error);
      setIsEditEnabled(isCategoryValid && noErrors);

      return updatedErrors;
    });
  };

  useEffect(() => {
    
    
    setCategoryData({
      name: Input.parent_category_name,
      children: Input.category_name ? [{ name: Input.category_name }] : [],
    });

    setUpdateCategoryData({
      name: editInput.parent_category_name,
      children: editInput.category_name
        ? [{ name: editInput.category_name }]
        : [],
    });
  }, [Input, editInput]);


  const handleClose = () => {
    setInput({ category_name: "", parent_category_name: "" });
    setEditInput({ category_name: "", parent_category_name: "" });
    setValidationErrors({});
    setCategoryData({ name: "Root", children: [] }); 
    setUpdateCategoryData({ name: "", children: [] }); 
    setIsParentDisabled(true);
    setOpenEditModal(false);
    setOpenDeleteModal(false);
    setOpenAddModal(false);
    setIsEditEnabled(false);
    setIsSaveEnabled(false);
  };

  
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedCategories = categories.slice(startIndex, endIndex);

  
  const handleRowsPerPageChange = (event, newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0); 
  };

  
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  


  const data = paginatedCategories.map((category, index) => ({
    s_no: startIndex + index + 1, 
    id: category.id,
    category_name: category.category_name,
    parent_category_name: category.parent_category_name,
    option: (
      <div style={{ display: "flex" }}>
        <IconButton
          color="info"
          size="small"
          onClick={() => {
            setEditInput({
              id: category.id,
              category_name: category.category_name,
              parent_category_name: category.parent_category_name,
            });
            
            setValidationErrors({
              category_name: validateName(category.category_name),
            });
            setIsEditEnabled(!!category.category_name && !validateName(category.category_name));
            setOpenEditModal(true);
          }}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          color="error"
          size="small"
          style={{ marginLeft: "5px" }}
          onClick={() => {
            setDeleteCategoryId(category.id);
            setOpenDeleteModal(true);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </div>
    ),
  }));

  return (
    <DashboardLayout>
      <MDBox display="flex" justifyContent="flex-end" alignItems="center">
        <LogoutButton
          onLogout={() => {
            navigate("/login");
          }}
        />
      </MDBox>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Category
                </MDTypography>
              </MDBox>
              <MDBox sx={{ textAlign: "right", mt: 4, mr: 4 }}>
                <MDButton color="success" onClick={() => {
                  setOpenAddModal(true);
                  
                  setInput({ category_name: "", parent_category_name: "" });
                  setIsParentDisabled(true);
                  setValidationErrors({});
                  setIsSaveEnabled(false);
                }}>
                  Add Category
                </MDButton>
              </MDBox>
              <MDBox p={3}>
                <DataTable
                  table={{ columns: columns, rows: data }}
                  isSorted={true}
                  entriesPerPage={{ defaultValue: rowsPerPage, entries: [5, 10, 15, 20, 25] }} 
                  showTotalEntries={true}
                  canSearch={true}
                  noEndBorder
                  headerColor="info"
                  pagination={{
                    variant: "contained",
                    color: "dark",
                    page: page, 
                    onPageChange: handlePageChange, 
                    rowsPerPage: rowsPerPage, 
                    onRowsPerPageChange: handleRowsPerPageChange, 
                    count: categories.length, 
                  }}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {}
      <Dialog open={openAddModal} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Add Category</DialogTitle>
        <MDBox component="form">
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDBox>
                  <TextField
                    label="Category Name"
                    name="category_name"
                    value={Input.category_name || ""}
                    onChange={handleAddChange}
                    fullWidth
                    margin="normal"
                    error={!!validationErrors.category_name}
                    helperText={validationErrors.category_name}
                  />
                  <MDBox display="flex" alignItems="center" mt={2}>
                    <Checkbox checked={!isParentDisabled} onChange={toggleParentCategory} color="primary" />
                    <MDTypography variant="body2" ml={1}>Enable Parent Category</MDTypography>
                  </MDBox>
                  <FormControl fullWidth margin="normal" disabled={isParentDisabled}>
                    <InputLabel id="parent-category-label">Parent Category</InputLabel>
                    <Select
                      labelId="parent-category-label"
                      label="Parent Category"
                      name="parent_category_name"
                      value={Input.parent_category_name || ""}
                      onChange={handleAddChange}
                      error={!!validationErrors.parent_category_name}
                      sx={{ height: "45px" }}
                    >
                      {categories.map((category) => (
                        <MenuItem key={category.id} value={category.category_name}>
                          {category.category_name}
                        </MenuItem>
                      ))}
                    </Select>
                    {validationErrors.parent_category_name && (
                      <MDTypography variant="caption" color="error">
                        {validationErrors.parent_category_name}
                      </MDTypography>
                    )}
                  </FormControl>
                </MDBox>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">Cancel</Button>
            <MDButton type="submit" color="success" onClick={addCategory} disabled={!isSaveEnabled}>
              Save
            </MDButton>
          </DialogActions>
        </MDBox>
      </Dialog>

      {}
      <Dialog
        open={openEditModal}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Edit Category</DialogTitle>
        <MDBox component="form">
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDBox>
                  <TextField
                    label="Category Name"
                    name="category_name"
                    value={editInput.category_name || ""}
                    onChange={handleEditChange}
                    fullWidth
                    margin="normal"
                    error={!!validationErrors.category_name}
                    helperText={validationErrors.category_name}
                  />
                  <FormControl fullWidth margin="normal">
                    <InputLabel id="edit-parent-category-label">
                      Parent Category
                    </InputLabel>
                    <Select
                      labelId="edit-parent-category-label"
                      id="edit-parent-category-select"
                      name="parent_category_name"
                      value={editInput.parent_category_name || ""}
                      label="Parent Category"
                      onChange={handleEditChange}
                      sx={{ height: "45px" }}
                    >
                      {categories.map((category) => (
                        <MenuItem
                          key={category.id}
                          value={category.category_name}
                        >
                          {category.category_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </MDBox>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <MDButton
              color="success"
              type="submit"
              onClick={updateCategory}
              disabled={!isEditEnabled}
            >
              Save
            </MDButton>
          </DialogActions>
        </MDBox>
      </Dialog>

      {}
      <Dialog open={openDeleteModal} onClose={handleClose}>
        <MDBox component="form" onSubmit={deleteCategory}>
          <DialogTitle>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <WarningIcon style={{ color: red[700], fontSize: 40 }} />
              </Grid>
              <Grid item>
                <MDTypography variant="h6" component="span">
                  Confirm Delete
                </MDTypography>
              </Grid>
            </Grid>
          </DialogTitle>

          <DialogContent>
            <MDBox
              p={2}
              style={{
                backgroundColor: red[50],
                borderLeft: `5px solid ${red[700]}`,
              }}
            >
              <MDTypography variant="body1">
                Are you sure you want to delete this item?
              </MDTypography>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton onClick={handleClose} style={{ color: "gray" }}>
              Cancel
            </MDButton>
            <MDButton type="submit" color="primary">
              Delete
            </MDButton>
          </DialogActions>
        </MDBox>
      </Dialog>
    </DashboardLayout>
  );
}

export default Category;